export default "__VITE_ASSET__mmgupCoJ__"